import React from "react";
import AppThemed from "./AppThemed.tsx";
import {GlobalAdmobProvider} from "./core/GlobalAdmob.tsx";
import InAppStoreProvider from "./InAppStoreProvider.tsx";
import JWTAuthProvider from "./JWTAuthProvider.tsx";

const AppContainer = ({children}) => {
    return (
        <JWTAuthProvider>
            <InAppStoreProvider>
                <GlobalAdmobProvider>
                    {children}
                </GlobalAdmobProvider>
            </InAppStoreProvider>
        </JWTAuthProvider>
    );
};

export default AppContainer;
